import { useState, useEffect } from 'react';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import { getBodyPartLabel } from "../../config/bodyZones";

const Carousel = ({ entries, onDeleteImage, onDeleteEntry }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      entries.length === 0 ? 0 : (prev - 1 + entries.length) % entries.length
    );
  }

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      entries.length === 0 ? 0 : (prev + 1) % entries.length
    );
  };

  useEffect(() => {
    if (currentIndex >= entries.length) {
      setCurrentIndex(Math.max(0, entries.length - 1));
    }
  }, [entries.length]);

  if (!entries || entries.length === 0) return null;

  const safeIndex = Math.max(0, Math.min(currentIndex, entries.length - 1));
  const currentEntry = entries[safeIndex];

  if (!currentEntry) return null;


  
  
  return (
    <div className="relative w-full max-w-2xl mx-auto mt-4">
      <div className="relative border border-gray-200 rounded-2xl bg-white shadow-sm px-14 py-10 h-auto min-h-[200px] flex flex-col items-center justify-center transition-all duration-300">
        <div className="absolute top-3 right-3">
          <button
            type="button"
            onClick={() => onDeleteEntry(safeIndex)}
            className="text-sm text-red-500 hover:text-red-700 transition flex items-center gap-1"
          >
            Supprimer cette lésion
          </button>
        </div>
        <div className="w-full flex flex-col items-center space-y-4 transition-all duration-300">
          {currentEntry.selectedPart && (
            <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-semibold">
              Zone: {getBodyPartLabel(currentEntry.selectedPart)}
            </span>
          )}

          

          {currentEntry.files.length > 0 && (
            <div className="flex flex-wrap gap-3 justify-center">
              {currentEntry.files.map((file, i) => (
                <div key={i} className="relative">
                  <img
                    key={i}
                    src={URL.createObjectURL(file)}
                    alt={`thumb-${i}`}
                    className="w-24 h-24 object-cover rounded-xl border border-gray-200"
                  />

                  <button
                    type="button"
                    onClick={() => onDeleteImage(safeIndex, i)}
                    className="
                      absolute
                      -top-2
                      -right-2
                      w-6
                      h-6
                      rounded-full
                      bg-red-500
                      text-white
                      flex
                      items-center
                      justify-center
                      shadow-md
                      hover:bg-red-600
                    "
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}

          {currentEntry.message && (
            <p className="text-gray-600 text-center text-base leading-relaxed break-words w-full">
              {currentEntry.message}
            </p>
          )}
        </div>

        {/* Navigation Buttons */}
        <button
          onClick={prevSlide}
          type='button'
          className="absolute left-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-gray-50 hover:bg-gray-100 text-gray-600 transition-colors border border-gray-200"
          aria-label="Previous"
        >
          <FaChevronLeft size={20} />
        </button>

        <button
          onClick={nextSlide}
          type='button'
          className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-gray-50 hover:bg-gray-100 text-gray-600 transition-colors border border-gray-200"
          aria-label="Next"
        >
          <FaChevronRight size={20} />
        </button>
      </div>

      {/* Pagination dots */}
      <div className="flex justify-center mt-4 gap-2">
        {entries.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setCurrentIndex(index)}
            className={`h-2 rounded-full transition-all ${
              currentIndex === index ? "bg-blue-500 w-2" : "bg-gray-300 w-2"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;